/**
 * TanStack Query keys for posts
 */

export const usersKeys = {
 all: ['users'] as const, 
 allUsers: (isActive?: boolean) => [...usersKeys.all, { isActive }] as const,
} as const